export async function subscribeTo(channelName, mixin) {
  const { consumer } = await import(/* webpackChunkName: "cable" */ "chunks/cable")
  return consumer.subscriptions.create(channelName, mixin)
}
